// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__315QB","question":"Question_question__22zmt","description":"Question_description__1x_00"};